var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable no-console */
/**
 * Operations of the ChatGPT embed (CONTRACT-piab.md §2.1), executed against
 * the app's Redux store with the app's own thunks/actions, so every rule the
 * app applies (Tacton commits, selection slots, tube types, auto routing,
 * calculation debounce) applies here too.
 *
 * Tacton commits are serialised: `setParametersInternal` has a `condition`
 * that DROPS a commit while another is in flight, so every step waits for the
 * request queue to go idle first and re-checks the result afterwards.
 */
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { t } from "i18next";
import { gripNodes, isCentral, objectShapeLabel, pumpNodes, readState, tubeConnectionNodes, tubeConnectionPorts, tubeConnectionLabel, userParameters, validComponents, } from "./piab-state";
import { actions } from "store/actions";
import { selectors } from "store/selectors";
import { TubeType, TubeConnectionId, tubeDiameterOptions, } from "store/types";
import { ChoiceType, NumberType, } from "api/types";
import { systemDataConstants } from "api/system-data";
import { ComponentList } from "api/tacton/types";
import { objectShapes, feedPressurePointNodeId } from "3d/constants/common";
import { isMountingCompatibleWithSuctionCup } from "3d/helpers";
import { CameraViewId } from "3d/types";
export var SIMULATE_TIMEOUT_MS = 40000;
var TACTON_IDLE_TIMEOUT_MS = 25000;
var ATTACHMENT_TIMEOUT_MS = 12000;
var MAX_GRIPS_PER_OP = 12;
var sleep = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
var norm = function (s) { return s.toLowerCase().replace(/[^a-z0-9]/g, ""); };
var fmt = function (n, d) {
    if (d === void 0) { d = 2; }
    return String(Math.round(n * Math.pow(10, d)) / Math.pow(10, d));
};
var OpError = /** @class */ (function (_super) {
    __extends(OpError, _super);
    function OpError() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        /* Babel-transpiled subclasses of Error do not survive `instanceof`; use a marker. */
        _this.isOpError = true;
        return _this;
    }
    return OpError;
}(Error));
var isOpError = function (e) {
    return !!e &&
        typeof e === "object" &&
        e.isOpError === true;
};
/* ------------------------------------------------------------------ */
/* waiting                                                             */
/* ------------------------------------------------------------------ */
export function waitFor(pred, timeoutMs, stepMs) {
    if (stepMs === void 0) { stepMs = 60; }
    return __awaiter(this, void 0, Promise, function () {
        var t0;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    t0 = Date.now();
                    _a.label = 1;
                case 1:
                    if (!(Date.now() - t0 < timeoutMs)) return [3 /*break*/, 3];
                    if (pred())
                        return [2 /*return*/, true];
                    return [4 /*yield*/, sleep(stepMs)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, pred()];
            }
        });
    });
}
function tactonBusy(state) {
    return (state.systemDataDefineParameters.dataState.isLoading ||
        state.systemDataSelectApplication.dataState.isLoading);
}
/** Wait until the Tacton request queue is idle for two consecutive polls. */
export function waitTactonIdle(store, timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = TACTON_IDLE_TIMEOUT_MS; }
    return __awaiter(this, void 0, Promise, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, waitFor(function () { return !tactonBusy(store.getState()); }, timeoutMs)];
                case 1:
                    ok = _a.sent();
                    if (!ok)
                        throw new OpError("Tacton did not answer in time");
                    return [4 /*yield*/, sleep(80)];
                case 2:
                    _a.sent();
                    if (!tactonBusy(store.getState())) return [3 /*break*/, 4];
                    return [4 /*yield*/, waitTactonIdle(store, timeoutMs)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function waitAttachments(store, needs, timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = ATTACHMENT_TIMEOUT_MS; }
    return __awaiter(this, void 0, Promise, function () {
        var s;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, waitFor(function () {
                        var s = store.getState().scene.present;
                        return needs.every(function (_a) {
                            var _b, _c;
                            var id = _a.id, n = _a.n;
                            return ((_c = (_b = s.nodes[id]) === null || _b === void 0 ? void 0 : _b.attachmentIds.length) !== null && _c !== void 0 ? _c : 0) >= n;
                        });
                    }, timeoutMs)];
                case 1:
                    _a.sent();
                    s = store.getState().scene.present;
                    return [2 /*return*/, needs
                            .filter(function (_a) {
                            var _b, _c;
                            var id = _a.id, n = _a.n;
                            return ((_c = (_b = s.nodes[id]) === null || _b === void 0 ? void 0 : _b.attachmentIds.length) !== null && _c !== void 0 ? _c : 0) < n;
                        })
                            .map(function (x) { return x.id; })];
            }
        });
    });
}
/** Match by value, exact label, normalised label, then unique prefix / substring. */
export function resolveNamed(list, query, what) {
    var _a;
    var q = String(query).trim();
    var nq = norm(q);
    var hit = (_a = list.find(function (c) { return c.value === q; })) !== null && _a !== void 0 ? _a : list.find(function (c) { return c.label === q; });
    if (hit)
        return { item: hit, inexact: false };
    hit = list.find(function (c) { return norm(c.label) === nq || norm(c.value) === nq; });
    if (hit)
        return { item: hit, inexact: false };
    if (nq.length >= 3) {
        var starts = list.filter(function (c) { return norm(c.label).startsWith(nq); });
        /* substring both ways, but a label may only match INSIDE the query when it is long enough to be
         * distinctive ("Min" must not match "target parts per minute"). */
        var includes = starts.length
            ? starts
            : list.filter(function (c) {
                return norm(c.label).includes(nq) ||
                    (norm(c.label).length >= 6 && nq.includes(norm(c.label)));
            });
        if (includes.length === 1)
            return { item: includes[0], inexact: true };
        if (includes.length > 1) {
            includes.sort(function (a, b) { return a.label.length - b.label.length; });
            return { item: includes[0], inexact: true };
        }
    }
    var valid = list
        .map(function (c) { return c.label; })
        .slice(0, 40)
        .join(", ");
    throw new OpError("\"".concat(q, "\" is not a valid ").concat(what, "; valid now: ").concat(valid).concat(list.length > 40 ? " \u2026 (".concat(list.length, " total)") : ""));
}
function selectIndices(sel, count, what) {
    var e_1, _a;
    if (sel === "all")
        return Array.from({ length: count }, function (_, i) { return i; });
    var arr = Array.isArray(sel) ? sel : [sel];
    var out = [];
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var n = arr_1_1.value;
            var i = Number(n);
            if (!Number.isInteger(i) || i < 1 || i > count)
                throw new OpError("".concat(what, " ").concat(n, " does not exist (there are ").concat(count, ")"));
            out.push(i - 1);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
function emptyValue(list) {
    return "".concat(list, "_X");
}
var OpsExecutor = /** @class */ (function () {
    function OpsExecutor(store, hooks) {
        if (hooks === void 0) { hooks = {}; }
        this.store = store;
        this.hooks = hooks;
    }
    Object.defineProperty(OpsExecutor.prototype, "state", {
        get: function () {
            return this.store.getState();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpsExecutor.prototype, "dispatch", {
        get: function () {
            return this.store.dispatch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpsExecutor.prototype, "systemData", {
        get: function () {
            return this.state.systemDataDefineParameters.dataState.data;
        },
        enumerable: false,
        configurable: true
    });
    /** Apply ops in order; one failing op is reported and the rest continue (each op is atomic where the app allows). */
    OpsExecutor.prototype.apply = function (ops, options) {
        var _a, _b, _c, _d;
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, Promise, function () {
            var result, i, op, e_2, msg, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        result = { changed: [], consequences: [], errors: [] };
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 1:
                        _f.sent();
                        i = 0;
                        _f.label = 2;
                    case 2:
                        if (!(i < ops.length)) return [3 /*break*/, 10];
                        op = ops[i];
                        if (options.deadline && Date.now() > options.deadline) {
                            result.errors.push("aborted before op ".concat(i + 1, " (").concat((_a = op === null || op === void 0 ? void 0 : op.op) !== null && _a !== void 0 ? _a : "?", "): the request's deadline passed (the view was hidden or too slow); ").concat(ops.length - i, " of ").concat(ops.length, " ops not applied"));
                            return [3 /*break*/, 10];
                        }
                        (_b = options.onProgress) === null || _b === void 0 ? void 0 : _b.call(options, i + 1, ops.length, (_c = op === null || op === void 0 ? void 0 : op.op) !== null && _c !== void 0 ? _c : "?");
                        _f.label = 3;
                    case 3:
                        _f.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.applyOne(op, result)];
                    case 4:
                        _f.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _f.sent();
                        msg = e_2 instanceof Error ? e_2.message : String(e_2);
                        result.errors.push("op ".concat(i + 1, " (").concat((_d = op === null || op === void 0 ? void 0 : op.op) !== null && _d !== void 0 ? _d : "?", "): ").concat(msg));
                        if (!isOpError(e_2))
                            console.error("[embed] op failed", op, e_2);
                        return [3 /*break*/, 6];
                    case 6:
                        _f.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 7:
                        _f.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        _e = _f.sent();
                        return [3 /*break*/, 9];
                    case 9:
                        i++;
                        return [3 /*break*/, 2];
                    case 10:
                        try {
                            this.dispatch(actions.deselectEntities());
                        }
                        catch (_g) {
                            /* ignore */
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    OpsExecutor.prototype.applyOne = function (op, r) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_b) {
                switch (op.op) {
                    case "application":
                        return [2 /*return*/, this.application(op, r)];
                    case "system_type":
                        return [2 /*return*/, this.systemType(op, r)];
                    case "set":
                        return [2 /*return*/, this.setParameters(op, r)];
                    case "object":
                        return [2 /*return*/, this.object(op, r)];
                    case "add_grip":
                        return [2 /*return*/, this.addGrip(op, r)];
                    case "set_grip":
                        return [2 /*return*/, this.setGrip(op, r)];
                    case "remove_grip":
                        return [2 /*return*/, this.removeGrip(op, r)];
                    case "add_pump":
                        return [2 /*return*/, this.addPump(op, r)];
                    case "set_pump":
                        return [2 /*return*/, this.setPump(op, r)];
                    case "remove_pump":
                        return [2 /*return*/, this.removePump(op, r)];
                    case "add_connection":
                        return [2 /*return*/, this.addConnection(op, r)];
                    case "connect":
                        return [2 /*return*/, this.connect(op, r)];
                    case "tubes":
                        return [2 /*return*/, this.tubes(op, r)];
                    case "disconnect":
                        this.dispatch(actions.deleteAllEdges());
                        r.changed.push("Removed all tubes");
                        return [2 /*return*/];
                    case "simulate":
                        return [2 /*return*/, this.simulate(op, r)];
                    case "camera":
                        this.camera(op.preset);
                        r.changed.push("Camera: ".concat((_a = op.preset) !== null && _a !== void 0 ? _a : "fit"));
                        return [2 /*return*/];
                    case "clear":
                        return [2 /*return*/, this.clear(op, r)];
                    default:
                        throw new OpError("unknown op \"".concat(op.op, "\""));
                }
                return [2 /*return*/];
            });
        });
    };
    /* ---------------- application / system ---------------- */
    OpsExecutor.prototype.application = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var appParam, options, item, cupsBefore, keep, after;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        appParam = selectors.selectApplicationNames(this.state);
                        if (!appParam)
                            throw new OpError("Tacton application data is not loaded yet");
                        options = appParam.options.map(function (o) { return ({
                            value: o.value,
                            label: o.label,
                        }); });
                        item = resolveNamed(options, op.id, "application").item;
                        if (item.value === appParam.value) {
                            r.changed.push("Application already ".concat(item.label));
                            return [2 /*return*/];
                        }
                        cupsBefore = readState(this.state).grips.map(function (g) { var _a, _b; return (_b = (_a = g.cup) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : null; });
                        keep = op.keep !== false;
                        this.dispatch(actions.clearLatestSelectedCup());
                        if (item.value !== "application_cardboard")
                            this.dispatch(actions.setCardboardManualThroughLeak(undefined));
                        if (!!keep) return [3 /*break*/, 4];
                        this.dispatch(actions.resetScene());
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this.dispatch(actions.resetParametersToDefault())];
                    case 2:
                        _c.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [4 /*yield*/, this.dispatch(actions.setParametersSelectApplication({
                            parameters: [appParam.id],
                            values: [item.value],
                        }))];
                    case 5:
                        _c.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 6:
                        _c.sent();
                        this.dispatch(UndoActionCreators.clearHistory());
                        this.dispatch(actions.clearSnapshots());
                        after = readState(this.state);
                        r.changed.push("Application set to ".concat(item.label).concat(keep ? "" : " (system reset)"));
                        if (keep) {
                            after.grips.forEach(function (g, i) {
                                if (cupsBefore[i] && !g.cup)
                                    r.consequences.push("Cup ".concat(cupsBefore[i], " on grip ").concat(g.index, " is not valid for ").concat(item.label, " and was cleared by Tacton"));
                            });
                        }
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.systemType = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var current, tubesBefore, value, now;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (op.type !== "central" && op.type !== "decentral")
                            throw new OpError('type must be "central" or "decentral"');
                        current = isCentral(this.state) ? "central" : "decentral";
                        if (current === op.type) {
                            r.changed.push("System is already ".concat(op.type));
                            return [2 /*return*/];
                        }
                        tubesBefore = Object.keys(this.state.scene.present.edges).length;
                        value = op.type === "central"
                            ? systemDataConstants.parameterValues.centralizedSystem
                            : systemDataConstants.parameterValues.decentralizedSystem;
                        return [4 /*yield*/, this.commit([systemDataConstants.parameterNames.vacuumSystemType], [value], r)];
                    case 1:
                        _c.sent();
                        now = isCentral(this.state) ? "central" : "decentral";
                        if (now !== op.type)
                            throw new OpError("Tacton did not accept the ".concat(op.type, " system"));
                        r.changed.push("Switched to a ".concat(op.type, " system"));
                        if (tubesBefore > 0)
                            r.consequences.push("Switching central/decentral removes all tubes in OVM Pro (".concat(tubesBefore, " removed); run connect again"));
                        if (op.type === "decentral" && pumpNodes(this.state).length)
                            r.consequences.push("Central pumps are hidden in a decentral system; each grip position needs its own pump");
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** One Tacton commit with conflict auto-acceptance. */
    OpsExecutor.prototype.commit = function (parameters, values, r) {
        return __awaiter(this, void 0, Promise, function () {
            var conflict, changes, errors, failed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.dispatch(actions.setParametersDefineParameters({ parameters: parameters, values: values }))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 3:
                        _a.sent();
                        conflict = selectors.selectConflict(this.state);
                        if (!conflict) return [3 /*break*/, 6];
                        changes = conflict.proposedChanges.map(function (c) {
                            return "".concat(c.newParameter.label, ": ").concat(c.oldParameter.value, " \u2192 ").concat(c.newParameter.value);
                        });
                        return [4 /*yield*/, this.dispatch(actions.setParametersDefineParameters({
                                parameters: __spreadArray(__spreadArray([], __read(conflict.proposedChanges.map(function (c) { return c.newParameter.id; })), false), [
                                    conflict.conflictingParameter.id,
                                ], false),
                                values: __spreadArray(__spreadArray([], __read(conflict.proposedChanges.map(function (c) { return c.newParameter.value; })), false), [
                                    conflict.conflictingParameter.value,
                                ], false),
                            }))];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 5:
                        _a.sent();
                        r.consequences.push("Tacton resolved a conflict by also changing ".concat(changes.join("; ")));
                        _a.label = 6;
                    case 6:
                        errors = this.state.systemDataDefineParameters.dataState.errors;
                        if (errors === null || errors === void 0 ? void 0 : errors.length) {
                            failed = errors.flatMap(function (e) { var _a, _b, _c, _d; return (_d = (_b = (_a = e.extra) === null || _a === void 0 ? void 0 : _a.parameters) !== null && _b !== void 0 ? _b : (_c = e.extra) === null || _c === void 0 ? void 0 : _c.components) !== null && _d !== void 0 ? _d : []; });
                            if (failed.length)
                                throw new OpError("Tacton rejected ".concat(failed.join(", "), " (").concat(errors[0].message, ")"));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.setParameters = function (op, r) {
        var _a, _b, _c;
        return __awaiter(this, void 0, Promise, function () {
            var systemData, params, ids, values, asked, _d, _e, _f, key, raw, p, param, value, opts, normalised, n, v, min, max, e_3_1, after, asked_1, asked_1_1, _g, p, value, now, same;
            var e_3, _h, e_4, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        systemData = this.systemData;
                        if (!systemData)
                            throw new OpError("Tacton parameters are not loaded yet");
                        if (!op.parameters || typeof op.parameters !== "object")
                            throw new OpError("parameters must be an object of id → value");
                        params = userParameters(systemData);
                        ids = [];
                        values = [];
                        asked = [];
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 7, 8, 9]);
                        _d = __values(Object.entries(op.parameters)), _e = _d.next();
                        _k.label = 2;
                    case 2:
                        if (!!_e.done) return [3 /*break*/, 6];
                        _f = __read(_e.value, 2), key = _f[0], raw = _f[1];
                        p = resolveNamed(params.map(function (x) { return ({ value: x.id, label: x.label, p: x }); }), key, "parameter id").item;
                        param = p.p;
                        value = void 0;
                        if (param.type === ChoiceType.DROPDOWN ||
                            param.type === ChoiceType.IMAGE_SELECT) {
                            opts = param.options.map(function (o) { return ({ value: o.value, label: o.label }); });
                            normalised = typeof raw === "boolean" ? (raw ? "Yes" : "No") : String(raw);
                            value = resolveNamed(opts, normalised, "value for ".concat(param.label)).item
                                .value;
                        }
                        else {
                            n = Number(raw);
                            if (!Number.isFinite(n))
                                throw new OpError("".concat(param.label, " needs a number"));
                            v = n;
                            min = param.type === ChoiceType.SLIDER
                                ? param.sliderMin
                                : param.min;
                            max = param.type === ChoiceType.SLIDER
                                ? param.sliderMax
                                : param.max;
                            if (min !== undefined && v < min) {
                                v = min;
                                r.consequences.push("".concat(param.label, " clamped to its minimum ").concat(min));
                            }
                            if (max !== undefined && v > max) {
                                v = max;
                                r.consequences.push("".concat(param.label, " clamped to its maximum ").concat(max));
                            }
                            if (param.type === NumberType.INT)
                                v = Math.round(v);
                            value = String(v);
                        }
                        if (!(param.id === systemDataConstants.parameterNames.vacuumSystemType)) return [3 /*break*/, 4];
                        /* route through systemType for its consequences */
                        return [4 /*yield*/, this.systemType({
                                type: value === systemDataConstants.parameterValues.centralizedSystem
                                    ? "central"
                                    : "decentral",
                            }, r)];
                    case 3:
                        /* route through systemType for its consequences */
                        _k.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        ids.push(param.id);
                        values.push(value);
                        asked.push({ p: param, value: value });
                        _k.label = 5;
                    case 5:
                        _e = _d.next();
                        return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_3_1 = _k.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_e && !_e.done && (_h = _d.return)) _h.call(_d);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        if (ids.length === 0)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.commit(ids, values, r)];
                    case 10:
                        _k.sent();
                        after = (_b = (_a = this.systemData) === null || _a === void 0 ? void 0 : _a.parameters) !== null && _b !== void 0 ? _b : {};
                        try {
                            for (asked_1 = __values(asked), asked_1_1 = asked_1.next(); !asked_1_1.done; asked_1_1 = asked_1.next()) {
                                _g = asked_1_1.value, p = _g.p, value = _g.value;
                                now = (_c = after[p.id]) === null || _c === void 0 ? void 0 : _c.value;
                                same = now === value ||
                                    (Number.isFinite(Number(now)) &&
                                        Number.isFinite(Number(value)) &&
                                        Number(now) === Number(value));
                                if (same)
                                    r.changed.push("Set ".concat(p.label, " to ").concat(value).concat(p.unit ? " ".concat(p.unit) : ""));
                                else
                                    r.consequences.push("Tacton kept ".concat(p.label, " at ").concat(now, " instead of ").concat(value));
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (asked_1_1 && !asked_1_1.done && (_j = asked_1.return)) _j.call(asked_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------- object ---------------- */
    OpsExecutor.prototype.object = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var shapes, list, item, shapeId, shape, cur, range, clamp, isCylinder, x, d, next;
            return __generator(this, function (_c) {
                if (op.shape) {
                    shapes = selectors.selectObjectShapes(this.state);
                    list = Object.keys(shapes).map(function (id) { return ({
                        value: id,
                        label: objectShapeLabel(id),
                    }); });
                    item = resolveNamed(list, op.shape, "object shape for this application").item;
                    if (item.value !== this.state.scene.present.objectShape) {
                        this.dispatch(actions.setObjectShape(item.value));
                        r.changed.push("Handled object set to ".concat(item.label));
                        if (gripNodes(this.state).length)
                            r.consequences.push("Grip positions were moved onto the new object's surface (app behaviour)");
                    }
                }
                if (op.size) {
                    shapeId = this.state.scene.present.objectShape;
                    shape = objectShapes[shapeId];
                    if (!(shape === null || shape === void 0 ? void 0 : shape.adjustableObject))
                        throw new OpError("".concat(objectShapeLabel(shapeId), " has a fixed size; only the adjustable shapes take a size"));
                    cur = this.state.scene.present.objectSize;
                    range = shape.sizeRange;
                    clamp = function (v, min, max, name) {
                        if (name === void 0) { name = ""; }
                        var out = v;
                        if (min !== undefined && out < min) {
                            out = min;
                            r.consequences.push("".concat(name, " clamped to ").concat(min, " m"));
                        }
                        if (max !== undefined && out > max) {
                            out = max;
                            r.consequences.push("".concat(name, " clamped to ").concat(max, " m"));
                        }
                        return out;
                    };
                    isCylinder = shape.adjustableObject.type === "cylinder";
                    x = op.size.x !== undefined
                        ? clamp(Number(op.size.x), range === null || range === void 0 ? void 0 : range.min.x, range === null || range === void 0 ? void 0 : range.max.x, "length")
                        : cur.x;
                    d = op.size.y !== undefined
                        ? clamp(Number(op.size.y), range === null || range === void 0 ? void 0 : range.min.y, range === null || range === void 0 ? void 0 : range.max.y, isCylinder ? "diameter" : "width")
                        : undefined;
                    next = isCylinder
                        ? { x: x, y: d !== null && d !== void 0 ? d : cur.y, z: d !== null && d !== void 0 ? d : cur.z }
                        : { x: x, y: cur.y, z: d !== null && d !== void 0 ? d : cur.z };
                    this.dispatch(actions.setObjectSize(next));
                    r.changed.push(isCylinder
                        ? "Object size: length ".concat(fmt(next.x), " m, diameter ").concat(fmt(next.z), " m")
                        : "Object size: ".concat(fmt(next.x), " \u00D7 ").concat(fmt(next.z), " m"));
                }
                (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                return [2 /*return*/];
            });
        });
    };
    /* ---------------- grips ---------------- */
    OpsExecutor.prototype.gripIds = function (sel) {
        var nodes = gripNodes(this.state);
        if (nodes.length === 0)
            throw new OpError("there are no grip positions");
        return selectIndices(sel, nodes.length, "grip").map(function (i) { return nodes[i].id; });
    };
    OpsExecutor.prototype.addGrip = function (op, r) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __awaiter(this, void 0, Promise, function () {
            var count, before, i, added, shapeId, y, spacing_1, n, cols_1, rows_1, ox_1, oz_1;
            var _this = this;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        count = Math.max(1, Math.min(MAX_GRIPS_PER_OP, Math.round(Number((_a = op.count) !== null && _a !== void 0 ? _a : 1))));
                        if (!this.systemData)
                            throw new OpError("Tacton data is not loaded yet");
                        before = new Set(gripNodes(this.state).map(function (n) { return n.id; }));
                        for (i = 0; i < count; i++) {
                            if (!selectors.selectCanAddGripPosition(this.state))
                                break;
                            this.dispatch(actions.addGripPosition());
                        }
                        added = gripNodes(this.state).filter(function (n) { return !before.has(n.id); });
                        if (added.length === 0)
                            throw new OpError("could not add a grip position: Tacton has no free suction-cup slot left (the app's maximum is reached)");
                        if (added.length < count)
                            r.consequences.push("Only ".concat(added.length, " of ").concat(count, " grip positions could be added (Tacton slot limit)"));
                        shapeId = this.state.scene.present.objectShape;
                        y = (_c = (_b = objectShapes[shapeId]) === null || _b === void 0 ? void 0 : _b.gripPositionY) !== null && _c !== void 0 ? _c : added[0].position.y;
                        if (op.layout) {
                            spacing_1 = Number((_d = op.layout.spacing) !== null && _d !== void 0 ? _d : 0.25);
                            n = added.length;
                            cols_1 = op.layout.pattern === "row"
                                ? n
                                : Number((_e = op.layout.cols) !== null && _e !== void 0 ? _e : Math.ceil(Math.sqrt(n)));
                            if (op.layout.rows && !op.layout.cols)
                                cols_1 = Math.ceil(n / Number(op.layout.rows));
                            cols_1 = Math.max(1, Math.min(n, Math.round(cols_1)));
                            rows_1 = Math.ceil(n / cols_1);
                            ox_1 = (_g = (_f = op.position) === null || _f === void 0 ? void 0 : _f.x) !== null && _g !== void 0 ? _g : 0;
                            oz_1 = (_j = (_h = op.position) === null || _h === void 0 ? void 0 : _h.z) !== null && _j !== void 0 ? _j : 0;
                            added.forEach(function (node, i) {
                                var c = i % cols_1;
                                var rw = Math.floor(i / cols_1);
                                _this.dispatch(actions.setNodePosition({
                                    nodeId: node.id,
                                    position: {
                                        x: ox_1 + (c - (cols_1 - 1) / 2) * spacing_1,
                                        y: y,
                                        z: oz_1 + (rw - (rows_1 - 1) / 2) * spacing_1,
                                    },
                                }));
                            });
                        }
                        else if (op.position) {
                            this.dispatch(actions.setNodePosition({
                                nodeId: added[0].id,
                                position: { x: Number(op.position.x), y: y, z: Number(op.position.z) },
                            }));
                        }
                        r.changed.push("Added ".concat(added.length, " grip position").concat(added.length > 1 ? "s" : "").concat(op.layout ? " in a ".concat((_k = op.layout.pattern) !== null && _k !== void 0 ? _k : "grid") : ""));
                        return [4 /*yield*/, this.applyComponents(added.map(function (n) { return n.id; }), op, r)];
                    case 1:
                        _o.sent();
                        (_m = (_l = this.hooks).onSceneChanged) === null || _m === void 0 ? void 0 : _m.call(_l);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.setGrip = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var ids, ids_1, ids_1_1, id, node;
            var e_5, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        ids = this.gripIds(op.grip);
                        if (op.position) {
                            try {
                                for (ids_1 = __values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
                                    id = ids_1_1.value;
                                    node = this.state.scene.present.nodes[id];
                                    this.dispatch(actions.setNodePosition({
                                        nodeId: id,
                                        position: {
                                            x: op.position.x !== undefined
                                                ? Number(op.position.x)
                                                : node.position.x,
                                            y: node.position.y,
                                            z: op.position.z !== undefined
                                                ? Number(op.position.z)
                                                : node.position.z,
                                        },
                                    }));
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (ids_1_1 && !ids_1_1.done && (_c = ids_1.return)) _c.call(ids_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                            r.changed.push("Moved grip ".concat(this.describeSel(op.grip)));
                        }
                        return [4 /*yield*/, this.applyComponents(ids, op, r)];
                    case 1:
                        _d.sent();
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.describeSel = function (sel) {
        return sel === "all"
            ? "positions (all)"
            : Array.isArray(sel)
                ? sel.join(", ")
                : String(sel);
    };
    /** Select cup / mounting / technology / decentral pump on the given grips, one Tacton commit per component kind. */
    OpsExecutor.prototype.applyComponents = function (ids, op, r) {
        return __awaiter(this, void 0, Promise, function () {
            var label, cups, _a, item_1, inexact, now, missed, after, still, mountings, cups_1, compatible, _b, item_2, inexact, technologies, _c, item, inexact, pumps, _d, item_3, inexact, after, still;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        label = ids.length === 1 ? "grip ".concat(this.indexOf(ids[0])) : "".concat(ids.length, " grips");
                        if (!(op.cup !== undefined)) return [3 /*break*/, 6];
                        if (!(op.cup === null)) return [3 /*break*/, 2];
                        this.dispatch(actions.selectCup({
                            nodeIds: ids,
                            value: emptyValue(ComponentList.SUCTION_CUP),
                        }));
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 1:
                        _e.sent();
                        r.changed.push("Cleared the cup on ".concat(label));
                        return [3 /*break*/, 6];
                    case 2:
                        cups = validComponents(this.systemData).cups;
                        _a = resolveNamed(cups, op.cup, "suction cup"), item_1 = _a.item, inexact = _a.inexact;
                        this.dispatch(actions.selectCup({ nodeIds: ids, value: item_1.value }));
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 3:
                        _e.sent();
                        now = readState(this.state).grips.filter(function (g) {
                            return ids.includes(g.id);
                        });
                        missed = now.filter(function (g) { var _a; return ((_a = g.cup) === null || _a === void 0 ? void 0 : _a.value) !== item_1.value; });
                        if (!(missed.length && missed.length === now.length)) return [3 /*break*/, 5];
                        /* a dropped commit (queue race) – retry once */
                        this.dispatch(actions.selectCup({ nodeIds: ids, value: item_1.value }));
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5:
                        after = readState(this.state).grips.filter(function (g) {
                            return ids.includes(g.id);
                        });
                        still = after.filter(function (g) { var _a; return ((_a = g.cup) === null || _a === void 0 ? void 0 : _a.value) !== item_1.value; });
                        if (still.length)
                            throw new OpError("Tacton did not accept ".concat(item_1.label, " on grip ").concat(still
                                .map(function (g) { return g.index; })
                                .join(", ")));
                        r.changed.push("Cup ".concat(item_1.label, " on ").concat(label).concat(inexact ? " (matched from \"".concat(op.cup, "\")") : ""));
                        _e.label = 6;
                    case 6:
                        if (!(op.mounting !== undefined)) return [3 /*break*/, 12];
                        if (!(op.mounting === null)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.dispatch(actions.selectCupMounting({
                                nodeIds: ids,
                                value: emptyValue(ComponentList.CUP_MOUNTING),
                            }))];
                    case 7:
                        _e.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 8:
                        _e.sent();
                        r.changed.push("Cleared the cup mounting on ".concat(label));
                        return [3 /*break*/, 12];
                    case 9:
                        mountings = validComponents(this.systemData).mountings;
                        cups_1 = ids.map(function (id) {
                            return selectors.selectSelectedCup(id)(_this.state);
                        });
                        compatible = mountings.filter(function (m) {
                            return cups_1.every(function (c) { return isMountingCompatibleWithSuctionCup(c, m); });
                        });
                        _b = resolveNamed(compatible.length ? compatible : mountings, op.mounting, "cup mounting for the selected cup"), item_2 = _b.item, inexact = _b.inexact;
                        if (!compatible.some(function (m) { return m.value === item_2.value; }))
                            r.consequences.push("".concat(item_2.label, " is not listed as compatible with the selected cup; applied anyway"));
                        return [4 /*yield*/, this.dispatch(actions.selectCupMounting({ nodeIds: ids, value: item_2.value }))];
                    case 10:
                        _e.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 11:
                        _e.sent();
                        r.changed.push("Cup mounting ".concat(item_2.label, " on ").concat(label).concat(inexact ? " (matched from \"".concat(op.mounting, "\")") : ""));
                        _e.label = 12;
                    case 12:
                        if (!(op.technology !== undefined)) return [3 /*break*/, 18];
                        if (!(op.technology === null)) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.dispatch(actions.selectCupTechnology({
                                nodeIds: ids,
                                value: emptyValue(ComponentList.CUP_TECHNOLOGY),
                            }))];
                    case 13:
                        _e.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 14:
                        _e.sent();
                        r.changed.push("Cleared the cup technology on ".concat(label));
                        return [3 /*break*/, 18];
                    case 15:
                        technologies = validComponents(this.systemData).technologies;
                        if (!technologies.length)
                            throw new OpError("no cup technologies are available for the selected cups (piGRIP cups only)");
                        _c = resolveNamed(technologies, op.technology, "cup technology"), item = _c.item, inexact = _c.inexact;
                        return [4 /*yield*/, this.dispatch(actions.selectCupTechnology({ nodeIds: ids, value: item.value }))];
                    case 16:
                        _e.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 17:
                        _e.sent();
                        r.changed.push("Cup technology ".concat(item.label, " on ").concat(label).concat(inexact ? " (matched from \"".concat(op.technology, "\")") : ""));
                        _e.label = 18;
                    case 18:
                        if (!(op.pump !== undefined)) return [3 /*break*/, 24];
                        if (isCentral(this.state))
                            throw new OpError("pumps on grip positions exist only in a decentral system; use add_pump for a central pump, or system_type decentral");
                        if (!(op.pump === null)) return [3 /*break*/, 21];
                        return [4 /*yield*/, this.dispatch(actions.selectDecentralPump({
                                nodeIds: ids,
                                value: emptyValue(ComponentList.VACUUM_PUMP),
                            }))];
                    case 19:
                        _e.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 20:
                        _e.sent();
                        r.changed.push("Cleared the pump on ".concat(label));
                        return [3 /*break*/, 24];
                    case 21:
                        pumps = validComponents(this.systemData).pumps;
                        _d = resolveNamed(pumps, op.pump, "decentral pump"), item_3 = _d.item, inexact = _d.inexact;
                        return [4 /*yield*/, this.dispatch(actions.selectDecentralPump({ nodeIds: ids, value: item_3.value }))];
                    case 22:
                        _e.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 23:
                        _e.sent();
                        after = readState(this.state).grips.filter(function (g) {
                            return ids.includes(g.id);
                        });
                        still = after.filter(function (g) { var _a; return ((_a = g.pump) === null || _a === void 0 ? void 0 : _a.value) !== item_3.value; });
                        if (still.length)
                            throw new OpError("Tacton did not accept pump ".concat(item_3.label, " on grip ").concat(still
                                .map(function (g) { return g.index; })
                                .join(", ")));
                        r.changed.push("Pump ".concat(item_3.label, " on ").concat(label).concat(inexact ? " (matched from \"".concat(op.pump, "\")") : ""));
                        _e.label = 24;
                    case 24: return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.indexOf = function (nodeId) {
        var nodes = __spreadArray(__spreadArray(__spreadArray([], __read(gripNodes(this.state)), false), __read(pumpNodes(this.state)), false), __read(tubeConnectionNodes(this.state)), false);
        var grips = gripNodes(this.state);
        var gi = grips.findIndex(function (n) { return n.id === nodeId; });
        if (gi >= 0)
            return gi + 1;
        var pumps = pumpNodes(this.state);
        var pi = pumps.findIndex(function (n) { return n.id === nodeId; });
        if (pi >= 0)
            return pi + 1;
        return nodes.findIndex(function (n) { return n.id === nodeId; }) + 1;
    };
    OpsExecutor.prototype.removeGrip = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var ids, ids_2, ids_2_1, id, e_6_1;
            var e_6, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        ids = this.gripIds(op.grip);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, 8, 9]);
                        ids_2 = __values(ids), ids_2_1 = ids_2.next();
                        _d.label = 2;
                    case 2:
                        if (!!ids_2_1.done) return [3 /*break*/, 6];
                        id = ids_2_1.value;
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 3:
                        _d.sent();
                        this.dispatch(actions.deleteNode(id));
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        ids_2_1 = ids_2.next();
                        return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_6_1 = _d.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (ids_2_1 && !ids_2_1.done && (_c = ids_2.return)) _c.call(ids_2);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        r.changed.push("Removed ".concat(ids.length, " grip position").concat(ids.length > 1 ? "s" : ""));
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------- central pumps ---------------- */
    OpsExecutor.prototype.pumpIds = function (sel) {
        var nodes = pumpNodes(this.state);
        if (nodes.length === 0)
            throw new OpError("there are no central pumps");
        return selectIndices(sel, nodes.length, "pump").map(function (i) { return nodes[i].id; });
    };
    OpsExecutor.prototype.addPump = function (op, r) {
        var _a, _b, _c;
        return __awaiter(this, void 0, Promise, function () {
            var count, before, i, added, node;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!isCentral(this.state))
                            throw new OpError("central pumps exist only in a central system; in a decentral system give each grip a pump (add_grip/set_grip with pump), or system_type central first");
                        count = Math.max(1, Math.min(4, Math.round(Number((_a = op.count) !== null && _a !== void 0 ? _a : 1))));
                        before = new Set(pumpNodes(this.state).map(function (n) { return n.id; }));
                        i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(i < count)) return [3 /*break*/, 5];
                        if (!selectors.selectCanAddCentralizedPump(this.state))
                            return [3 /*break*/, 5];
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 2:
                        _d.sent();
                        this.dispatch(actions.addCentralizedPump());
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5:
                        added = pumpNodes(this.state).filter(function (n) { return !before.has(n.id); });
                        if (!added.length)
                            throw new OpError("could not add a central pump (the app allows at most 4, and Tacton must have a free pump slot)");
                        if (added.length < count)
                            r.consequences.push("Only ".concat(added.length, " of ").concat(count, " pumps could be added (limit 4)"));
                        if (op.position) {
                            node = added[0];
                            this.dispatch(actions.setNodePosition({
                                nodeId: node.id,
                                position: {
                                    x: Number(op.position.x),
                                    y: node.position.y,
                                    z: Number(op.position.z),
                                },
                            }));
                        }
                        r.changed.push("Added ".concat(added.length, " central pump").concat(added.length > 1 ? "s" : ""));
                        return [4 /*yield*/, this.applyPumpModel(added.map(function (n) { return n.id; }), op.model, r)];
                    case 6:
                        _d.sent();
                        (_c = (_b = this.hooks).onSceneChanged) === null || _c === void 0 ? void 0 : _c.call(_b);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.applyPumpModel = function (ids, model, r) {
        return __awaiter(this, void 0, Promise, function () {
            var pumps, now, labels, _a, item, inexact, after, still, final;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pumps = validComponents(this.systemData).pumps;
                        if (model === undefined) {
                            now = readState(this.state).pumps.filter(function (p) { return ids.includes(p.id); });
                            labels = __spreadArray([], __read(new Set(now.map(function (p) { var _a; return (_a = p.model) === null || _a === void 0 ? void 0 : _a.label; }).filter(Boolean))), false);
                            if (labels.length)
                                r.changed.push("Pump model (app default): ".concat(labels.join(", ")));
                            return [2 /*return*/];
                        }
                        _a = resolveNamed(pumps, model, "central pump"), item = _a.item, inexact = _a.inexact;
                        return [4 /*yield*/, this.dispatch(actions.selectCentralPump({ nodeIds: ids, value: item.value }))];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 2:
                        _b.sent();
                        after = readState(this.state).pumps.filter(function (p) { return ids.includes(p.id); });
                        still = after.filter(function (p) { var _a; return ((_a = p.model) === null || _a === void 0 ? void 0 : _a.value) !== item.value; });
                        if (!still.length) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.dispatch(actions.selectCentralPump({
                                nodeIds: still.map(function (p) { return p.id; }),
                                value: item.value,
                            }))];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        final = readState(this.state).pumps.filter(function (p) { var _a; return ids.includes(p.id) && ((_a = p.model) === null || _a === void 0 ? void 0 : _a.value) !== item.value; });
                        if (final.length)
                            throw new OpError("Tacton did not accept ".concat(item.label, " on pump ").concat(final
                                .map(function (p) { return p.index; })
                                .join(", ")));
                        r.changed.push("Pump model ".concat(item.label).concat(inexact ? " (matched from \"".concat(model, "\")") : "", " on ").concat(ids.length === 1
                            ? "pump ".concat(this.indexOf(ids[0]))
                            : "".concat(ids.length, " pumps")));
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.setPump = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var ids, ids_3, ids_3_1, id, node;
            var e_7, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        ids = this.pumpIds(op.pump);
                        if (op.position) {
                            try {
                                for (ids_3 = __values(ids), ids_3_1 = ids_3.next(); !ids_3_1.done; ids_3_1 = ids_3.next()) {
                                    id = ids_3_1.value;
                                    node = this.state.scene.present.nodes[id];
                                    this.dispatch(actions.setNodePosition({
                                        nodeId: id,
                                        position: {
                                            x: op.position.x !== undefined
                                                ? Number(op.position.x)
                                                : node.position.x,
                                            y: node.position.y,
                                            z: op.position.z !== undefined
                                                ? Number(op.position.z)
                                                : node.position.z,
                                        },
                                    }));
                                }
                            }
                            catch (e_7_1) { e_7 = { error: e_7_1 }; }
                            finally {
                                try {
                                    if (ids_3_1 && !ids_3_1.done && (_c = ids_3.return)) _c.call(ids_3);
                                }
                                finally { if (e_7) throw e_7.error; }
                            }
                            r.changed.push("Moved pump ".concat(this.describeSel(op.pump)));
                        }
                        if (!(op.model !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.applyPumpModel(ids, op.model, r)];
                    case 1:
                        _d.sent();
                        _d.label = 2;
                    case 2:
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.removePump = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var ids, ids_4, ids_4_1, id, e_8_1;
            var e_8, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        ids = this.pumpIds(op.pump);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, 8, 9]);
                        ids_4 = __values(ids), ids_4_1 = ids_4.next();
                        _d.label = 2;
                    case 2:
                        if (!!ids_4_1.done) return [3 /*break*/, 6];
                        id = ids_4_1.value;
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 3:
                        _d.sent();
                        this.dispatch(actions.deleteNode(id));
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        ids_4_1 = ids_4.next();
                        return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_8_1 = _d.sent();
                        e_8 = { error: e_8_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (ids_4_1 && !ids_4_1.done && (_c = ids_4.return)) _c.call(ids_4);
                        }
                        finally { if (e_8) throw e_8.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        r.changed.push("Removed ".concat(ids.length, " central pump").concat(ids.length > 1 ? "s" : ""));
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------- tube connections / tubes ---------------- */
    OpsExecutor.prototype.resolveConnectionType = function (type) {
        if (!type)
            return TubeConnectionId.THREE_WAY_T;
        var list = Object.values(TubeConnectionId).map(function (id) { return ({
            value: id,
            label: tubeConnectionLabel(id),
        }); });
        return resolveNamed(list, type, "tube connection type").item
            .value;
    };
    OpsExecutor.prototype.addConnectionNodes = function (type, count, position) {
        var ids = [];
        for (var i = 0; i < count; i++) {
            if (!selectors.selectCanAddTubeConnection(this.state))
                break;
            var id = this.dispatch(actions.addTubeConnection());
            if (!id)
                break;
            this.dispatch(actions.setTubeConnectionType({ type: type, nodeIds: [id] }));
            if (position && i === 0) {
                var node = this.state.scene.present.nodes[id];
                this.dispatch(actions.setNodePosition({
                    nodeId: id,
                    position: {
                        x: Number(position.x),
                        y: node.position.y,
                        z: Number(position.z),
                    },
                }));
            }
            ids.push(id);
        }
        return ids;
    };
    OpsExecutor.prototype.addConnection = function (op, r) {
        var _a, _b, _c;
        return __awaiter(this, void 0, Promise, function () {
            var type, ids;
            return __generator(this, function (_d) {
                type = this.resolveConnectionType(op.type);
                ids = this.addConnectionNodes(type, Math.max(1, Math.min(10, Math.round(Number((_a = op.count) !== null && _a !== void 0 ? _a : 1)))), op.position);
                if (!ids.length)
                    throw new OpError("could not add a tube connection (node id limit)");
                r.changed.push("Added ".concat(ids.length, " tube connection").concat(ids.length > 1 ? "s" : "", " (").concat(tubeConnectionLabel(type), ")"));
                (_c = (_b = this.hooks).onSceneChanged) === null || _c === void 0 ? void 0 : _c.call(_b);
                return [2 /*return*/];
            });
        });
    };
    /** Splitter that gains at least `deficit` extra outputs (net gain = ports - 2). */
    OpsExecutor.prototype.pickSplitter = function (deficit) {
        if (deficit <= 1)
            return TubeConnectionId.THREE_WAY_T;
        if (deficit <= 2)
            return TubeConnectionId.FOUR_WAY_X;
        if (deficit <= 3)
            return TubeConnectionId.ONE_FOUR_FIVE_DISTRIBUTION_BLOCK;
        if (deficit <= 5)
            return TubeConnectionId.ONE_SIX_SEVEN_DISTRIBUTION_BLOCK;
        if (deficit <= 7)
            return TubeConnectionId.ONE_EIGHT_NINE_DISTRIBUTION_BLOCK;
        return TubeConnectionId.ONE_TEN_ELEVEN_DISTRIBUTION_BLOCK;
    };
    OpsExecutor.prototype.connect = function (op, r) {
        var _a, _b, _c;
        return __awaiter(this, void 0, Promise, function () {
            var st, central, targets, skipped, sources, capacity, added, forced, guard, deficit, type, ids, scene, needs, late, after, unconnected;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (op.clear)
                            this.dispatch(actions.deleteAllEdges());
                        st = readState(this.state);
                        central = st.systemType === "central";
                        targets = central
                            ? st.grips.filter(function (g) { return g.cup; })
                            : st.grips.filter(function (g) { return g.cup && g.pump; });
                        skipped = central
                            ? st.grips.filter(function (g) { return !g.cup; })
                            : st.grips.filter(function (g) { return !g.cup || !g.pump; });
                        if (skipped.length)
                            r.consequences.push("".concat(skipped.length, " grip position").concat(skipped.length > 1 ? "s" : "", " without a ").concat(central ? "cup" : "cup and pump", " cannot be connected: grip ").concat(skipped.map(function (g) { return g.index; }).join(", ")));
                        if (!targets.length)
                            throw new OpError(central
                                ? "nothing to connect: add grip positions with cups first"
                                : "nothing to connect: every grip position needs a cup and a pump in a decentral system");
                        sources = central ? st.pumps.filter(function (p) { return p.model; }).length : 1;
                        if (central && sources === 0)
                            throw new OpError("a central system needs a central pump first (add_pump)");
                        capacity = sources +
                            st.tubeConnections.reduce(function (n, c) { return n + Math.max(0, c.ports - 2); }, 0);
                        added = [];
                        forced = op.splitter
                            ? this.resolveConnectionType(op.splitter)
                            : undefined;
                        guard = 0;
                        while (capacity < targets.length && guard++ < 12) {
                            deficit = targets.length - capacity;
                            type = forced !== null && forced !== void 0 ? forced : this.pickSplitter(deficit);
                            ids = this.addConnectionNodes(type, 1);
                            if (!ids.length)
                                break;
                            added.push(tubeConnectionLabel(type));
                            capacity += Math.max(1, tubeConnectionPorts(type) - 2);
                        }
                        if (added.length)
                            r.changed.push("Added ".concat(added.length, " tube connection").concat(added.length > 1 ? "s" : "", ": ").concat(added.join(", ")));
                        scene = this.state.scene.present;
                        needs = __spreadArray(__spreadArray(__spreadArray([
                            { id: feedPressurePointNodeId, n: 1 }
                        ], __read(targets.map(function (g) { return ({ id: g.id, n: 1 }); })), false), __read((central
                            ? st.pumps.filter(function (p) { return p.model; }).map(function (p) { return ({ id: p.id, n: 2 }); })
                            : [])), false), __read(tubeConnectionNodes(this.state).map(function (n) { return ({
                            id: n.id,
                            n: Math.max(2, tubeConnectionPorts(scene.nodes[n.id].component.type)),
                        }); })), false);
                        return [4 /*yield*/, waitAttachments(this.store, needs)];
                    case 1:
                        late = _d.sent();
                        if (late.length)
                            r.consequences.push("".concat(late.length, " part(s) had no connection points yet (3D models still loading); run connect again"));
                        this.dispatch(actions.performAutoRouting());
                        return [4 /*yield*/, sleep(250)];
                    case 2:
                        _d.sent();
                        if (!!((_a = this.state.ui.checklist.connect_parts) === null || _a === void 0 ? void 0 : _a.completed)) return [3 /*break*/, 5];
                        return [4 /*yield*/, sleep(400)];
                    case 3:
                        _d.sent();
                        this.dispatch(actions.performAutoRouting());
                        return [4 /*yield*/, sleep(250)];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        after = readState(this.state);
                        unconnected = __spreadArray(__spreadArray([], __read(after.grips
                            .filter(function (g) { return targets.some(function (tg) { return tg.id === g.id; }) && !g.connected; })
                            .map(function (g) { return "grip ".concat(g.index); })), false), __read((central
                            ? after.pumps
                                .filter(function (p) { return p.model && !p.connected; })
                                .map(function (p) { return "pump ".concat(p.index); })
                            : [])), false);
                        r.changed.push("Connected the system: ".concat(after.tubes.count, " tube").concat(after.tubes.count === 1 ? "" : "s").concat(after.tubes.allConnected ? ", all parts connected" : ""));
                        if (unconnected.length)
                            r.consequences.push("Still unconnected: ".concat(unconnected.join(", "), " (add a tube connection or run connect again)"));
                        (_c = (_b = this.hooks).onSceneChanged) === null || _c === void 0 ? void 0 : _c.call(_b);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpsExecutor.prototype.tubes = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var scene, edges, ids, wanted_1, unit, opts_1, best_1, o, length;
            return __generator(this, function (_c) {
                scene = this.state.scene.present;
                edges = Object.values(scene.edges).filter(function (e) {
                    if (!op.target || op.target === "all")
                        return true;
                    return op.target === "vacuum"
                        ? e.tubeType === TubeType.VACUUM
                        : e.tubeType === TubeType.COMPRESSED_AIR;
                });
                if (!edges.length)
                    throw new OpError("there are no tubes yet (run connect first)");
                ids = edges.map(function (e) { return e.id; });
                if (op.diameterMm !== undefined) {
                    wanted_1 = Number(op.diameterMm) / 1000;
                    unit = this.state.ui.unitSystem;
                    opts_1 = tubeDiameterOptions[unit];
                    best_1 = 0;
                    opts_1.forEach(function (o, i) {
                        if (Math.abs(o.value - wanted_1) < Math.abs(opts_1[best_1].value - wanted_1))
                            best_1 = i;
                    });
                    o = opts_1[best_1];
                    this.dispatch(actions.setEdgeDiameterDefaultTube({
                        edgeIds: ids,
                        diameter: o.value,
                        index: best_1,
                    }));
                    this.dispatch(actions.setEdgeDiameterBlowOffTube({
                        edgeIds: ids,
                        diameter: o.value,
                        index: best_1,
                    }));
                    if (Math.abs(o.value - wanted_1) > 1e-6)
                        r.consequences.push("Tube inner diameter snapped to the nearest option ".concat(o.innerLabel, " ").concat(o.unit, " (outer ").concat(o.outerLabel, ")"));
                    r.changed.push("Tube inner diameter ".concat(o.innerLabel, " ").concat(o.unit, " on ").concat(ids.length, " tube").concat(ids.length > 1 ? "s" : ""));
                }
                if (op.lengthM !== undefined) {
                    length = Math.max(0.05, Number(op.lengthM));
                    this.dispatch(actions.setEdgeLength({ edgeIds: ids, length: length, isLocked: true }));
                    r.changed.push("Tube length ".concat(fmt(length), " m on ").concat(ids.length, " tube").concat(ids.length > 1 ? "s" : ""));
                }
                (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                return [2 /*return*/];
            });
        });
    };
    /* ---------------- simulate ---------------- */
    OpsExecutor.prototype.simulate = function (op, r) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, Promise, function () {
            var structural, settled, st, why, c, _e, _f, w, _g, _h, n;
            var e_9, _j, e_10, _k;
            var _this = this;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        structural = selectors.selectCalculatePerformanceStructuralErrorMessage(this.state);
                        if (structural)
                            throw new OpError(t(structural));
                        if (op.energySaving !== undefined)
                            this.dispatch(actions.setShowEnergySavePerformance(!!op.energySaving));
                        this.dispatch(actions.showPerformanceData());
                        return [4 /*yield*/, waitFor(function () {
                                var _a;
                                var p = _this.state.systemPerformance;
                                if (p.isLoading)
                                    return false;
                                return (p.isPerformanceDataValid ||
                                    p.hasSettledUserCalculation ||
                                    !!((_a = p.error) === null || _a === void 0 ? void 0 : _a.visible));
                            }, SIMULATE_TIMEOUT_MS, 120)];
                    case 1:
                        settled = _l.sent();
                        if (!settled)
                            throw new OpError("the calculation did not finish within 40 s");
                        st = readState(this.state);
                        if (!st.performance) {
                            why = st.issues.length
                                ? st.issues.join(" ")
                                : (_b = (_a = this.state.systemPerformance.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "the calculation returned no valid result";
                            throw new OpError("simulation failed: ".concat(why));
                        }
                        if (op.energySaving && !((_c = this.state.systemPerformance.data) === null || _c === void 0 ? void 0 : _c.energySavingOn))
                            r.consequences.push("Energy saving data is not available for this system; showing the data without energy saving");
                        c = st.performance.cycle;
                        r.changed.push(c
                            ? "Simulated: cycle ".concat(c.cycleTime, " s vs target ").concat(c.targetCycleTime, " s (").concat(c.meetsTarget ? "meets" : "misses", " target), time to part secured ").concat(c.timeToPartSecured, " s")
                            : "Simulated");
                        try {
                            for (_e = __values(st.performance.warnings), _f = _e.next(); !_f.done; _f = _e.next()) {
                                w = _f.value;
                                r.consequences.push(w);
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_j = _e.return)) _j.call(_e);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                        try {
                            for (_g = __values((_d = st.performance.notes) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()) {
                                n = _h.value;
                                r.consequences.push(n);
                            }
                        }
                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
                        finally {
                            try {
                                if (_h && !_h.done && (_k = _g.return)) _k.call(_g);
                            }
                            finally { if (e_10) throw e_10.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------- camera / clear ---------------- */
    OpsExecutor.prototype.camera = function (preset) {
        var p = (preset !== null && preset !== void 0 ? preset : "fit").toLowerCase();
        if (p === "top" || p === "edit")
            this.dispatch(actions.setCameraView(CameraViewId.EDIT_VIEW));
        else if (p.startsWith("node:") || p.startsWith("grip:")) {
            var idx = Number(p.split(":")[1]);
            var node = gripNodes(this.state)[idx - 1];
            if (node)
                this.dispatch(actions.selectNode(node.id));
        }
        else
            this.dispatch(actions.setCameraView(CameraViewId.INITIAL_3D_VIEW));
    };
    OpsExecutor.prototype.clear = function (op, r) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var had;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        had = gripNodes(this.state).length +
                            pumpNodes(this.state).length +
                            tubeConnectionNodes(this.state).length;
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 1:
                        _c.sent();
                        this.dispatch(actions.resetScene());
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 2:
                        _c.sent();
                        this.dispatch(actions.clearPerformanceData());
                        this.dispatch(UndoActionCreators.clearHistory());
                        this.dispatch(actions.clearSnapshots());
                        if (!op.parameters) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.dispatch(actions.resetParametersToDefault())];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, waitTactonIdle(this.store)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5:
                        r.changed.push(had
                            ? "Cleared the system (".concat(had, " part").concat(had > 1 ? "s" : "", " removed)").concat(op.parameters ? " and reset the parameters" : "")
                            : "System was already empty".concat(op.parameters ? "; parameters reset" : ""));
                        (_b = (_a = this.hooks).onSceneChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------- full-state catch-up ---------------- */
    /** Rebuild the system described by `target` (a state echoed earlier). Used when a fresh iframe joins a session. */
    OpsExecutor.prototype.loadState = function (target) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, Promise, function () {
            var current, ops, knownApps, params, _l, _m, _o, id, p, _p, _q, g, _r, _s, p, _t, _u, c, result;
            var e_11, _v, e_12, _w, e_13, _x, e_14, _y;
            return __generator(this, function (_z) {
                switch (_z.label) {
                    case 0:
                        current = readState(this.state);
                        if (systemEquals(current, target))
                            return [2 /*return*/, { changed: [], consequences: [], errors: [] }];
                        ops = [];
                        knownApps = ((_b = (_a = selectors.selectApplicationNames(this.state)) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : []).map(function (o) { return o.value; });
                        /* a server placeholder state may name an application Tacton does not offer: ignore it */
                        if (target.application &&
                            target.application.id !== ((_c = current.application) === null || _c === void 0 ? void 0 : _c.id) &&
                            knownApps.includes(target.application.id))
                            ops.push({ op: "application", id: target.application.id, keep: false });
                        else if (current.grips.length ||
                            current.pumps.length ||
                            current.tubeConnections.length)
                            ops.push({ op: "clear" });
                        if (target.systemType !== current.systemType)
                            ops.push({ op: "system_type", type: target.systemType });
                        params = {};
                        try {
                            for (_l = __values(Object.entries((_d = target.parameters) !== null && _d !== void 0 ? _d : {})), _m = _l.next(); !_m.done; _m = _l.next()) {
                                _o = __read(_m.value, 2), id = _o[0], p = _o[1];
                                if (id === systemDataConstants.parameterNames.vacuumSystemType)
                                    continue;
                                if (current.parameters[id] && current.parameters[id].value !== p.value)
                                    params[id] = p.value;
                            }
                        }
                        catch (e_11_1) { e_11 = { error: e_11_1 }; }
                        finally {
                            try {
                                if (_m && !_m.done && (_v = _l.return)) _v.call(_l);
                            }
                            finally { if (e_11) throw e_11.error; }
                        }
                        if (Object.keys(params).length)
                            ops.push({ op: "set", parameters: params });
                        if (((_e = target.object) === null || _e === void 0 ? void 0 : _e.shape) &&
                            (target.object.shape !== current.object.shape ||
                                JSON.stringify(target.object.size) !==
                                    JSON.stringify(current.object.size))) {
                            ops.push(__assign({ op: "object", shape: target.object.shape }, (target.object.size
                                ? { size: { x: target.object.size.x, y: target.object.size.z } }
                                : {})));
                        }
                        try {
                            for (_p = __values((_f = target.grips) !== null && _f !== void 0 ? _f : []), _q = _p.next(); !_q.done; _q = _p.next()) {
                                g = _q.value;
                                ops.push(__assign(__assign(__assign(__assign({ op: "add_grip", count: 1, position: g.position }, (g.cup ? { cup: g.cup.value } : {})), (g.mounting ? { mounting: g.mounting.value } : {})), (g.technology ? { technology: g.technology.value } : {})), (g.pump && target.systemType === "decentral"
                                    ? { pump: g.pump.value }
                                    : {})));
                            }
                        }
                        catch (e_12_1) { e_12 = { error: e_12_1 }; }
                        finally {
                            try {
                                if (_q && !_q.done && (_w = _p.return)) _w.call(_p);
                            }
                            finally { if (e_12) throw e_12.error; }
                        }
                        if (target.systemType === "central")
                            try {
                                for (_r = __values((_g = target.pumps) !== null && _g !== void 0 ? _g : []), _s = _r.next(); !_s.done; _s = _r.next()) {
                                    p = _s.value;
                                    ops.push(__assign({ op: "add_pump", count: 1, position: p.position }, (p.model ? { model: p.model.value } : {})));
                                }
                            }
                            catch (e_13_1) { e_13 = { error: e_13_1 }; }
                            finally {
                                try {
                                    if (_s && !_s.done && (_x = _r.return)) _x.call(_r);
                                }
                                finally { if (e_13) throw e_13.error; }
                            }
                        try {
                            for (_t = __values((_h = target.tubeConnections) !== null && _h !== void 0 ? _h : []), _u = _t.next(); !_u.done; _u = _t.next()) {
                                c = _u.value;
                                ops.push({ op: "add_connection", type: c.type, count: 1 });
                            }
                        }
                        catch (e_14_1) { e_14 = { error: e_14_1 }; }
                        finally {
                            try {
                                if (_u && !_u.done && (_y = _t.return)) _y.call(_t);
                            }
                            finally { if (e_14) throw e_14.error; }
                        }
                        if (((_k = (_j = target.tubes) === null || _j === void 0 ? void 0 : _j.count) !== null && _k !== void 0 ? _k : 0) > 0)
                            ops.push({ op: "connect" });
                        return [4 /*yield*/, this.apply(ops)];
                    case 1:
                        result = _z.sent();
                        result.changed = result.changed.length ? ["Loaded the system"] : [];
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return OpsExecutor;
}());
export { OpsExecutor };
/** The parts of the state that describe the SYSTEM (what a catch-up must reproduce). */
export function systemSignature(s) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return JSON.stringify({
        application: (_b = (_a = s.application) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
        systemType: s.systemType,
        object: s.object,
        parameters: Object.fromEntries(Object.entries((_c = s.parameters) !== null && _c !== void 0 ? _c : {}).map(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return [k, v.value];
        })),
        grips: ((_d = s.grips) !== null && _d !== void 0 ? _d : []).map(function (g) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return ({
                cup: (_b = (_a = g.cup) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null,
                mounting: (_d = (_c = g.mounting) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : null,
                technology: (_f = (_e = g.technology) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : null,
                pump: (_h = (_g = g.pump) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : null,
                position: g.position,
            });
        }),
        pumps: ((_e = s.pumps) !== null && _e !== void 0 ? _e : []).map(function (p) {
            var _a, _b;
            return ({
                model: (_b = (_a = p.model) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null,
                position: p.position,
            });
        }),
        tubeConnections: ((_f = s.tubeConnections) !== null && _f !== void 0 ? _f : []).map(function (c) { return c.type; }),
        tubes: (_h = (_g = s.tubes) === null || _g === void 0 ? void 0 : _g.count) !== null && _h !== void 0 ? _h : 0,
    });
}
export function systemEquals(a, b) {
    return systemSignature(a) === systemSignature(b);
}
